// элементы выбора
import React, { FC, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useTheme } from 'styled-components';
import { CSpan, FInter, FlexBox, useBreakpoint, useIsMobile } from '@brg/ui';
import { SCROLL_SELECT_ITEM_DELAY, SCROLL_SELECT_ITEM_HEIGHT, SCROLL_SELECT_ITEM_HEIGHT_FAVORITE } from './config';
import {
    Arrow,
    ChooserBox,
    ChooserBoxPart,
    ChooserContainer,
    ChooserNode,
    ChooserOpacity,
    ChooserOpacityBottom,
    ChooserOpacityTopFavoriteMoadal,
    Container,
    FavoriteIconCotainer,
    FavoriteSubTitle,
    FavoriteTitle,
    FavoriteTitleContainer,
    PrettyPoint,
} from './styles';
import { modalControllerActions, useModal } from '../../../core';
import { useContextLinksNew } from "../../components/navigationSystem/context/useContextLinksNew";
import { Link } from 'shared/components/link/Link';
import { AppTester } from 'supporting';
import FavoriteStartIcon from 'shared/icons/FavoriteStartIcon';
import { useTranslation } from 'react-i18next';
import { useProfile } from '@brg/auth';
import { DesignerAPI } from '@brg/api';
import { ConfirmPopUp } from '../ConfirmPopUp/ConfirmPopUp';
import { useDispatch } from 'react-redux';

/**
 * Контейнер с выбором элемента
 * @param props
 * @constructor
 */
export const SelectContextModalNew: FC<{ visible?: boolean, orientation?: string, isRussianGalllleryStyle?: boolean, isFavoritesVersion?: boolean, favoriteTitle?: string, favoriteSubtitle?: string }> = ({ visible, orientation = 'center', isRussianGalllleryStyle = false, isFavoritesVersion, favoriteTitle, favoriteSubtitle }) => {

    const [scrollingAnimation, setScrollingAnimation] = useState<any>(null);
    const [projectIndex, setProjectIndex] = useState(0);
    const profile = useProfile();
    const theme = useTheme();
    const modal = useModal();
    const isCGRAVE = AppTester.isCGRAVE();
    const isContinuumSite = AppTester.isContinuumSite();
    const isAdcrDafesNet = AppTester.isAdcrDafesNet();
    const isMobile = useBreakpoint(743)
    const { t } = useTranslation();
    const excludeContexts = isFavoritesVersion ? ['main', 'my'] : [];
    const { links, modalSettings: { title, titleColor } } = useContextLinksNew({isOnlyMediaContext: isFavoritesVersion, excludeIds: excludeContexts})
    const designerId = profile?.designerId
    const disableOpacity = isCGRAVE || isContinuumSite || isAdcrDafesNet;
    const [designer, setDesigner] = useState<any>(null);
    const [showConfirm, setShowConfirm] = useState(false);
    const [pendingLink, setPendingLink] = useState<{ linkTo: string; content: string; fullName: string } | null>(null);
    const dispatch = useDispatch();
    useEffect(() => {
        const loadDesigner = async () => {
            if (isFavoritesVersion && designerId) {
                try {
                    const designerData = await DesignerAPI.Get({ idDesigner: designerId }).then(r => r.json());
                    setDesigner(designerData);
                } catch (error) {
                    console.error('Error_loadDesigner', error);
                }
            }
            else return
        };
        loadDesigner();
    }, [isFavoritesVersion, designerId]);

    const updateFavorites = async (linkTo: string) => {
        if (!designerId || !designer) return false;
        try {
            const updatedDesigner = {
                ...designer,
                favoritePlatform: linkTo
            };
            
            const response = await DesignerAPI.Update(updatedDesigner);
            return response?.ok;
        } catch (error) {
            return false;
        }
    };

    const linkTitle = (link: { content?: string; menuTitleSuffix?: string } | undefined): string => {
        if (!link) return "";
        const c = link.content ?? "";
        const s = link.menuTitleSuffix;
        if (s === "") return c;
        if (s) return `${c}.${s}`;
        return title ? `${c}.${title}` : c;
    };

    const footerBrandLabel = (): string | null => {
        const link = links[projectIndex];
        if (!link) return title || null;
        const s = (link as { menuTitleSuffix?: string }).menuTitleSuffix;
        if (s === "") return null;
        if (s) return s;
        return title || null;
    };

    // реф для автоскролла
    const scrollRef = useRef<any>(null);

    // Как только все отрисовалось, надо перевести скролл "куда надо"
    useEffect(() => {
        if (scrollRef.current) {
            const ind = links.findIndex(link => link?.active)
            const scroller = scrollRef.current as HTMLDivElement;
            requestAnimationFrame(() => {
                scroller.scrollTo({ top: ind * (isFavoritesVersion ? SCROLL_SELECT_ITEM_HEIGHT_FAVORITE : SCROLL_SELECT_ITEM_HEIGHT) });

                setTimeout(() => {
                    setScrollingAnimation(false)
                }, 100)
            })            
        }
    }, [links, scrollRef]);

    /**
     * Событие нажатия на стрелочку
     */
    const onArrowClick = (e: React.MouseEvent<HTMLDivElement>, p?: number): void => {
        e.preventDefault();
        e.stopPropagation();

        const index = p ?? projectIndex;
        const selectedLink = links[index];
        
        if (isFavoritesVersion && selectedLink?.linkTo) {
            setPendingLink({
                linkTo: selectedLink.linkTo,
                content: selectedLink.content,
                fullName: `${selectedLink.content}.${title}`
            });
            setShowConfirm(true);
            dispatch(modalControllerActions.setConfirmPopUpOpen(true));
        }
        else {
             modal.hide();
            // @ts-ignore
            links[p ?? projectIndex]?.action && links[p ?? projectIndex]?.action()
        }
        // modal.hide();
        // // @ts-ignore
        // links[p ?? projectIndex]?.action && links[p ?? projectIndex]?.action()
    };

    /**
     * Фабрика с обработчиком событий
     * @param index
     */
    const onSomeItemClick = (index: number) => {
    /**
     * Обработчик события выбора элемента в списке
     */
        return async (ev: React.MouseEvent<HTMLDivElement>) => {
            ev.preventDefault();
            ev.stopPropagation();

            const selectedLink = links[index];
        
            // Получаем элемент скроллера
            const target = ev.target as HTMLDivElement;
            const scroller = scrollRef.current as HTMLDivElement;
            
            // Делаем скролл к выбранному элементу
            const scrollAmount = index * (isFavoritesVersion ? SCROLL_SELECT_ITEM_HEIGHT_FAVORITE : SCROLL_SELECT_ITEM_HEIGHT);
            scroller.scrollTo({ top: scrollAmount, behavior: 'smooth' });

            if (isFavoritesVersion && selectedLink?.linkTo) {
                // показываем модалку послен скролла
                setTimeout(() => {
                    setPendingLink({
                        linkTo: selectedLink.linkTo,
                        content: selectedLink.content,
                        fullName: `${selectedLink.content}.${title}`
                    });
                    setShowConfirm(true);
                    dispatch(modalControllerActions.setConfirmPopUpOpen(true));
                }, SCROLL_SELECT_ITEM_DELAY);
            } else {
                // Обычное меню
                setTimeout(
                    () => {
                        onArrowClick(ev, index);
                    },
                    scrollAmount !== scroller.scrollTop ? SCROLL_SELECT_ITEM_DELAY : 0);
                    }
            } 
            };

        const handleConfirm = async () => {
            if (pendingLink) {
                const success = await updateFavorites(pendingLink.linkTo);
                setShowConfirm(false);
                dispatch(modalControllerActions.setConfirmPopUpOpen(false));
                modal.hide();
                window.location.href = pendingLink.linkTo;
        }
    };

    const handleCancel = () => {
        setShowConfirm(false);
        setPendingLink(null);
    };

    if (isMobile && !visible && !isFavoritesVersion) {
        return null;
    }

    const showFooterBrand = (() => {
        const b = footerBrandLabel();
        return b != null && b !== "";
    })();

    if (orientation === 'right') {
        return (
            <Container customBg={isRussianGalllleryStyle ? "#e7e7e7" : ''}>
                <ChooserBox>
                    <ChooserBoxPart style={{ flex: 10 }} >
                        <ChooserOpacity isRussianGalllleryStyle={isRussianGalllleryStyle} />
                        <ChooserOpacityBottom isRussianGalllleryStyle={isRussianGalllleryStyle} />
                        <ChooserContainer
                            isRussianGalllleryStyle={isRussianGalllleryStyle}
                            onScroll={() => {
                                const scroller = scrollRef.current as HTMLDivElement;
                                setScrollingAnimation(Math.floor(scroller.scrollTop) % (isFavoritesVersion ? SCROLL_SELECT_ITEM_HEIGHT_FAVORITE: SCROLL_SELECT_ITEM_HEIGHT) !== 0);
                                const index = Math.floor(scroller.scrollTop / (isFavoritesVersion ? SCROLL_SELECT_ITEM_HEIGHT_FAVORITE: SCROLL_SELECT_ITEM_HEIGHT));
                                setProjectIndex(index);
                            }}
                            ref={scrollRef}
                            direction={'column'}
                            directionMobile={'column'}
                            align={'flex-end'}
                            alignMobile={'flex-end'}
                            width={'100%'}
                            isFavoritesVersion={isFavoritesVersion}
                        >
                            {links.map((value, index) => (
                                <a href={value?.linkTo || ''} title={value?.content + '.' + title}>
                                    <FInter.MainTitleSmallDiv
                                        className={'sc-item'}
                                        onClick={onSomeItemClick(index)}
                                        color={theme.selectContextModal.variantTextColor}
                                        key={value?.content + index}
                                    >
                                        <ChooserNode isFavoritesVersion={isFavoritesVersion} style={isRussianGalllleryStyle ? { width: '100%', whiteSpace: 'wrap' } : { whiteSpace: 'nowrap' }}>{value?.content || ''}</ChooserNode>
                                    </FInter.MainTitleSmallDiv>
                                </a>
                            ))}
                        </ChooserContainer>
                    </ChooserBoxPart>
                    <ChooserBoxPart style={{ flex: 1 }} align={'center'} alignMobile={'center'}>
                        <FlexBox align={'center'} alignMobile={'center'}>
                            <>&nbsp;</>
                            {!scrollingAnimation && <Arrow onClick={(e) => onArrowClick(e)}>→</Arrow>}
                        </FlexBox>
                    </ChooserBoxPart>
                </ChooserBox>
            </Container>
        )
    }

    return (
        <Container isFavoritesVersion={isFavoritesVersion}>
            {isFavoritesVersion && <FavoriteTitleContainer>
                <FavoriteTitle>{t(favoriteTitle!)}</FavoriteTitle>
                <FavoriteSubTitle>{t(favoriteSubtitle!)}</FavoriteSubTitle>
            </FavoriteTitleContainer>}
            <ChooserBox isFavoritesVersion={isFavoritesVersion}>
                <ChooserBoxPart isFavoritesVersion={isFavoritesVersion}>
                    {isFavoritesVersion && <ChooserOpacityTopFavoriteMoadal/>}
                    <ChooserOpacity disableOpacity={disableOpacity} isFavoritesVersion={isFavoritesVersion}/>
                    <ChooserOpacityBottom disableOpacity={disableOpacity} isFavoritesVersion={isFavoritesVersion}/>
                    <ChooserContainer
                        onScroll={(e) => {
                            const scroller = scrollRef.current as HTMLDivElement;
                            setScrollingAnimation(Math.floor(scroller.scrollTop % (isFavoritesVersion ? SCROLL_SELECT_ITEM_HEIGHT_FAVORITE: SCROLL_SELECT_ITEM_HEIGHT)) !== 0);
                            const index = Math.floor(scroller.scrollTop / (isFavoritesVersion ? SCROLL_SELECT_ITEM_HEIGHT_FAVORITE: SCROLL_SELECT_ITEM_HEIGHT));
                            setProjectIndex(index);
                        }}
                        ref={scrollRef}
                        direction={'column'}
                        directionMobile={'column'}
                        align={'flex-end'}
                        alignMobile={'flex-end'}
                        width={'100%'}
                        isFavoritesVersion={isFavoritesVersion}
                    >
                        {links.map((value, index) => {
                            return (
                                <a href={value?.linkTo || ''} title={linkTitle(value)}>
                                    <FInter.MainTitleSmallDiv
                                        className={'sc-item'}
                                        onClick={onSomeItemClick(index)}
                                        color={theme.selectContextModal.variantTextColor}
                                        key={index}
                                    >
                                        <ChooserNode isFavoritesVersion={isFavoritesVersion}>{value?.content || ''}</ChooserNode>
                                    </FInter.MainTitleSmallDiv>
                                </a>
                            )
                        })}
                    </ChooserContainer>
                </ChooserBoxPart>

                <ChooserBoxPart style={{ cursor: 'pointer' }} align={'center'} alignMobile={'center'} onClick={(e) => onArrowClick(e)} isFavoritesVersion={isFavoritesVersion}>
                    <FInter.MainTitleSmallDiv color={theme.selectContextModal.variantTextColor}>
                        <a href={`${links[projectIndex]?.linkTo}`} title={linkTitle(links[projectIndex])}>
                            <FlexBox align={'center'} alignMobile={'center'}>
                                {showFooterBrand && (
                                    <>
                                        <PrettyPoint visible={!scrollingAnimation}>.</PrettyPoint>
                                        <CSpan color={titleColor}>{footerBrandLabel()}</CSpan>&nbsp;
                                    </>
                                )}
                                {isFavoritesVersion && <FavoriteIconCotainer><FavoriteStartIcon/></FavoriteIconCotainer>}
                                {!scrollingAnimation && !isFavoritesVersion && <Arrow /*externalLink={links[projectIndex]?.externalLink}*/>→</Arrow>}
                            </FlexBox>
                        </a>
                    </FInter.MainTitleSmallDiv>
                </ChooserBoxPart>
            </ChooserBox>
            {/* Confirm Popup */}
        {showConfirm && pendingLink && (
            <ConfirmPopUp
                title={`${t('confirm.favorite.title')} ${pendingLink?.fullName} ${t('confirm.favorite.favorite')}`}
                onSave={handleConfirm}
                onCancel={handleCancel}
                saveText={t('confirm.favorite.save')}
                cancelText={t('confirm.favorite.cancel')}
            />
        )}
        </Container>
        
    );
};
// элементы выбора
import React, { FC, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useTheme } from 'styled-components';
import { CSpan, FInter, FlexBox, useBreakpoint, useIsMobile } from '@brg/ui';
import { SCROLL_SELECT_ITEM_DELAY, SCROLL_SELECT_ITEM_HEIGHT, SCROLL_SELECT_ITEM_HEIGHT_FAVORITE } from './config';
import {
    Arrow,
    ChooserBox,
    ChooserBoxPart,
    ChooserContainer,
    ChooserNode,
    ChooserOpacity,
    ChooserOpacityBottom,
    ChooserOpacityTopFavoriteMoadal,
    Container,
    FavoriteIconCotainer,
    FavoriteSubTitle,
    FavoriteTitle,
    FavoriteTitleContainer,
    PrettyPoint,
} from './styles';
import { modalControllerActions, useModal } from '../../../core';
import { useContextLinksNew } from "../../components/navigationSystem/context/useContextLinksNew";
import { Link } from 'shared/components/link/Link';
import { AppTester } from 'supporting';
import FavoriteStartIcon from 'shared/icons/FavoriteStartIcon';
import { useTranslation } from 'react-i18next';
import { useProfile } from '@brg/auth';
import { DesignerAPI } from '@brg/api';
import { ConfirmPopUp } from '../ConfirmPopUp/ConfirmPopUp';
import { useDispatch } from 'react-redux';

/**
 * Контейнер с выбором элемента
 * @param props
 * @constructor
 */
export const SelectContextModalNew: FC<{ visible?: boolean, orientation?: string, isRussianGalllleryStyle?: boolean, isFavoritesVersion?: boolean, favoriteTitle?: string, favoriteSubtitle?: string }> = ({ visible, orientation = 'center', isRussianGalllleryStyle = false, isFavoritesVersion, favoriteTitle, favoriteSubtitle }) => {

    const [scrollingAnimation, setScrollingAnimation] = useState<any>(null);
    const [projectIndex, setProjectIndex] = useState(0);
    const profile = useProfile();
    const theme = useTheme();
    const modal = useModal();
    const isCGRAVE = AppTester.isCGRAVE();
    const isContinuumSite = AppTester.isContinuumSite();
    const isAdcrDafesNet = AppTester.isAdcrDafesNet();
    const isMobile = useBreakpoint(743)
    const { t } = useTranslation();
    const excludeContexts = isFavoritesVersion ? ['main', 'my'] : [];
    const { links, modalSettings: { title, titleColor } } = useContextLinksNew({isOnlyMediaContext: isFavoritesVersion, excludeIds: excludeContexts})
    const designerId = profile?.designerId
    const disableOpacity = isCGRAVE || isContinuumSite || isAdcrDafesNet;
    const [designer, setDesigner] = useState<any>(null);
    const [showConfirm, setShowConfirm] = useState(false);
    const [pendingLink, setPendingLink] = useState<{ linkTo: string; content: string; fullName: string } | null>(null);
    const dispatch = useDispatch();
    useEffect(() => {
        const loadDesigner = async () => {
            if (isFavoritesVersion && designerId) {
                try {
                    const designerData = await DesignerAPI.Get({ idDesigner: designerId }).then(r => r.json());
                    setDesigner(designerData);
                } catch (error) {
                    console.error('Error_loadDesigner', error);
                }
            }
            else return
        };
        loadDesigner();
    }, [isFavoritesVersion, designerId]);

    const updateFavorites = async (linkTo: string) => {
        if (!designerId || !designer) return false;
        try {
            const updatedDesigner = {
                ...designer,
                favoritePlatform: linkTo
            };
            
            const response = await DesignerAPI.Update(updatedDesigner);
            return response?.ok;
        } catch (error) {
            return false;
        }
    };

    const linkTitle = (link: { content?: string; menuTitleSuffix?: string } | undefined): string => {
        if (!link) return "";
        const c = link.content ?? "";
        const s = link.menuTitleSuffix;
        if (s === "") return c;
        if (s) return `${c}.${s}`;
        return title ? `${c}.${title}` : c;
    };

    const footerBrandLabel = (): string | null => {
        const link = links[projectIndex];
        if (!link) return title || null;
        const s = (link as { menuTitleSuffix?: string }).menuTitleSuffix;
        if (s === "") return null;
        if (s) return s;
        return title || null;
    };

    // реф для автоскролла
    const scrollRef = useRef<any>(null);

    // Как только все отрисовалось, надо перевести скролл "куда надо"
    useEffect(() => {
        if (scrollRef.current) {
            const ind = links.findIndex(link => link?.active)
            const scroller = scrollRef.current as HTMLDivElement;
            requestAnimationFrame(() => {
                scroller.scrollTo({ top: ind * (isFavoritesVersion ? SCROLL_SELECT_ITEM_HEIGHT_FAVORITE : SCROLL_SELECT_ITEM_HEIGHT) });

                setTimeout(() => {
                    setScrollingAnimation(false)
                }, 100)
            })            
        }
    }, [links, scrollRef]);

    /**
     * Событие нажатия на стрелочку
     */
    const onArrowClick = (e: React.MouseEvent<HTMLDivElement>, p?: number): void => {
        e.preventDefault();
        e.stopPropagation();

        const index = p ?? projectIndex;
        const selectedLink = links[index];
        
        if (isFavoritesVersion && selectedLink?.linkTo) {
            setPendingLink({
                linkTo: selectedLink.linkTo,
                content: selectedLink.content,
                fullName: `${selectedLink.content}.${title}`
            });
            setShowConfirm(true);
            dispatch(modalControllerActions.setConfirmPopUpOpen(true));
        }
        else {
             modal.hide();
            // @ts-ignore
            links[p ?? projectIndex]?.action && links[p ?? projectIndex]?.action()
        }
        // modal.hide();
        // // @ts-ignore
        // links[p ?? projectIndex]?.action && links[p ?? projectIndex]?.action()
    };

    /**
     * Фабрика с обработчиком событий
     * @param index
     */
    const onSomeItemClick = (index: number) => {
    /**
     * Обработчик события выбора элемента в списке
     */
        return async (ev: React.MouseEvent<HTMLDivElement>) => {
            ev.preventDefault();
            ev.stopPropagation();

            const selectedLink = links[index];
        
            // Получаем элемент скроллера
            const target = ev.target as HTMLDivElement;
            const scroller = scrollRef.current as HTMLDivElement;
            
            // Делаем скролл к выбранному элементу
            const scrollAmount = index * (isFavoritesVersion ? SCROLL_SELECT_ITEM_HEIGHT_FAVORITE : SCROLL_SELECT_ITEM_HEIGHT);
            scroller.scrollTo({ top: scrollAmount, behavior: 'smooth' });

            if (isFavoritesVersion && selectedLink?.linkTo) {
                // показываем модалку послен скролла
                setTimeout(() => {
                    setPendingLink({
                        linkTo: selectedLink.linkTo,
                        content: selectedLink.content,
                        fullName: `${selectedLink.content}.${title}`
                    });
                    setShowConfirm(true);
                    dispatch(modalControllerActions.setConfirmPopUpOpen(true));
                }, SCROLL_SELECT_ITEM_DELAY);
            } else {
                // Обычное меню
                setTimeout(
                    () => {
                        onArrowClick(ev, index);
                    },
                    scrollAmount !== scroller.scrollTop ? SCROLL_SELECT_ITEM_DELAY : 0);
                    }
            } 
            };

        const handleConfirm = async () => {
            if (pendingLink) {
                const success = await updateFavorites(pendingLink.linkTo);
                setShowConfirm(false);
                dispatch(modalControllerActions.setConfirmPopUpOpen(false));
                modal.hide();
                window.location.href = pendingLink.linkTo;
        }
    };

    const handleCancel = () => {
        setShowConfirm(false);
        setPendingLink(null);
    };

    if (isMobile && !visible && !isFavoritesVersion) {
        return null;
    }

    const showFooterBrand = (() => {
        const b = footerBrandLabel();
        return b != null && b !== "";
    })();

    if (orientation === 'right') {
        return (
            <Container customBg={isRussianGalllleryStyle ? "#e7e7e7" : ''}>
                <ChooserBox>
                    <ChooserBoxPart style={{ flex: 10 }} >
                        <ChooserOpacity isRussianGalllleryStyle={isRussianGalllleryStyle} />
                        <ChooserOpacityBottom isRussianGalllleryStyle={isRussianGalllleryStyle} />
                        <ChooserContainer
                            isRussianGalllleryStyle={isRussianGalllleryStyle}
                            onScroll={() => {
                                const scroller = scrollRef.current as HTMLDivElement;
                                setScrollingAnimation(Math.floor(scroller.scrollTop) % (isFavoritesVersion ? SCROLL_SELECT_ITEM_HEIGHT_FAVORITE: SCROLL_SELECT_ITEM_HEIGHT) !== 0);
                                const index = Math.floor(scroller.scrollTop / (isFavoritesVersion ? SCROLL_SELECT_ITEM_HEIGHT_FAVORITE: SCROLL_SELECT_ITEM_HEIGHT));
                                setProjectIndex(index);
                            }}
                            ref={scrollRef}
                            direction={'column'}
                            directionMobile={'column'}
                            align={'flex-end'}
                            alignMobile={'flex-end'}
                            width={'100%'}
                            isFavoritesVersion={isFavoritesVersion}
                        >
                            {links.map((value, index) => (
                                <a href={value?.linkTo || ''} title={value?.content + '.' + title}>
                                    <FInter.MainTitleSmallDiv
                                        className={'sc-item'}
                                        onClick={onSomeItemClick(index)}
                                        color={theme.selectContextModal.variantTextColor}
                                        key={value?.content + index}
                                    >
                                        <ChooserNode isFavoritesVersion={isFavoritesVersion} style={isRussianGalllleryStyle ? { width: '100%', whiteSpace: 'wrap' } : { whiteSpace: 'nowrap' }}>{value?.content || ''}</ChooserNode>
                                    </FInter.MainTitleSmallDiv>
                                </a>
                            ))}
                        </ChooserContainer>
                    </ChooserBoxPart>
                    <ChooserBoxPart style={{ flex: 1 }} align={'center'} alignMobile={'center'}>
                        <FlexBox align={'center'} alignMobile={'center'}>
                            <>&nbsp;</>
                            {!scrollingAnimation && <Arrow onClick={(e) => onArrowClick(e)}>→</Arrow>}
                        </FlexBox>
                    </ChooserBoxPart>
                </ChooserBox>
            </Container>
        )
    }

    return (
        <Container isFavoritesVersion={isFavoritesVersion}>
            {isFavoritesVersion && <FavoriteTitleContainer>
                <FavoriteTitle>{t(favoriteTitle!)}</FavoriteTitle>
                <FavoriteSubTitle>{t(favoriteSubtitle!)}</FavoriteSubTitle>
            </FavoriteTitleContainer>}
            <ChooserBox isFavoritesVersion={isFavoritesVersion}>
                <ChooserBoxPart isFavoritesVersion={isFavoritesVersion}>
                    {isFavoritesVersion && <ChooserOpacityTopFavoriteMoadal/>}
                    <ChooserOpacity disableOpacity={disableOpacity} isFavoritesVersion={isFavoritesVersion}/>
                    <ChooserOpacityBottom disableOpacity={disableOpacity} isFavoritesVersion={isFavoritesVersion}/>
                    <ChooserContainer
                        onScroll={(e) => {
                            const scroller = scrollRef.current as HTMLDivElement;
                            setScrollingAnimation(Math.floor(scroller.scrollTop % (isFavoritesVersion ? SCROLL_SELECT_ITEM_HEIGHT_FAVORITE: SCROLL_SELECT_ITEM_HEIGHT)) !== 0);
                            const index = Math.floor(scroller.scrollTop / (isFavoritesVersion ? SCROLL_SELECT_ITEM_HEIGHT_FAVORITE: SCROLL_SELECT_ITEM_HEIGHT));
                            setProjectIndex(index);
                        }}
                        ref={scrollRef}
                        direction={'column'}
                        directionMobile={'column'}
                        align={'flex-end'}
                        alignMobile={'flex-end'}
                        width={'100%'}
                        isFavoritesVersion={isFavoritesVersion}
                    >
                        {links.map((value, index) => {
                            return (
                                <a href={value?.linkTo || ''} title={linkTitle(value)}>
                                    <FInter.MainTitleSmallDiv
                                        className={'sc-item'}
                                        onClick={onSomeItemClick(index)}
                                        color={theme.selectContextModal.variantTextColor}
                                        key={index}
                                    >
                                        <ChooserNode isFavoritesVersion={isFavoritesVersion}>{value?.content || ''}</ChooserNode>
                                    </FInter.MainTitleSmallDiv>
                                </a>
                            )
                        })}
                    </ChooserContainer>
                </ChooserBoxPart>

                <ChooserBoxPart style={{ cursor: 'pointer' }} align={'center'} alignMobile={'center'} onClick={(e) => onArrowClick(e)} isFavoritesVersion={isFavoritesVersion}>
                    <FInter.MainTitleSmallDiv color={theme.selectContextModal.variantTextColor}>
                        <a href={`${links[projectIndex]?.linkTo}`} title={linkTitle(links[projectIndex])}>
                            <FlexBox align={'center'} alignMobile={'center'}>
                                {showFooterBrand && (
                                    <>
                                        <PrettyPoint visible={!scrollingAnimation}>.</PrettyPoint>
                                        <CSpan color={titleColor}>{footerBrandLabel()}</CSpan>&nbsp;
                                    </>
                                )}
                                {isFavoritesVersion && <FavoriteIconCotainer><FavoriteStartIcon/></FavoriteIconCotainer>}
                                {!scrollingAnimation && !isFavoritesVersion && <Arrow /*externalLink={links[projectIndex]?.externalLink}*/>→</Arrow>}
                            </FlexBox>
                        </a>
                    </FInter.MainTitleSmallDiv>
                </ChooserBoxPart>
            </ChooserBox>
            {/* Confirm Popup */}
        {showConfirm && pendingLink && (
            <ConfirmPopUp
                title={`${t('confirm.favorite.title')} ${pendingLink?.fullName} ${t('confirm.favorite.favorite')}`}
                onSave={handleConfirm}
                onCancel={handleCancel}
                saveText={t('confirm.favorite.save')}
                cancelText={t('confirm.favorite.cancel')}
            />
        )}
        </Container>
        
    );
};
